module.exports = __webpack_public_path__ + "img/r.a0c6ce5d.jpg";